/* eslint-disable react/button-has-type */
import { LoadingOutlined } from '@ant-design/icons';
import React, { ButtonHTMLAttributes } from 'react';
import { Typography } from 'tfc-components';

import Icon, { IconName, IconSize } from 'components/atoms/Icon';
import mapModifiers from 'utils/functions';

type TSize = 'p10x16' | 'p12' | 'p8x12' | 'p6x12';
type THeight = 'h40' | 'h32' | 'h44';
type TIconProps = {
  align: 'left' | 'right';
  size: IconSize;
  name: IconName
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  icon?: TIconProps;
  variant?: 'primary' | 'secondary' | 'outline' | 'icon' | 'transparent' | 'tertiaryGray' | 'blue-crayola' | 'tertiary';
  modifiers?: (TSize | THeight)[];
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl',
  buttonType?: 'icon' | 'button',
  isLoading?: boolean,
  isFullWidth?: boolean,
  loadingColor?: string
  fontBase?: string
}

const ButtonCustom: React.FC<ButtonProps> = ({
  children, type = 'button', icon, variant = 'primary', modifiers, isLoading, isFullWidth, loadingColor, className, size, fontBase, ...props
}) => (
  <button
    type={type}
    className={`${className || ''} ${mapModifiers('a-buttonCustom', variant, modifiers && modifiers, isFullWidth && 'fullWidth', size, props.buttonType && props.buttonType)}`}
    {...props}
  >
    {isLoading ? <LoadingOutlined width={20} style={{ color: loadingColor || (variant ? '#344054' : '#fff') }} /> : (
      <>
        {icon && icon.align === 'left' && <span className="a-buttonCustom_icon-left"><Icon iconName={icon.name} size={icon.size} /></span>}
        {
          children && (
            <Typography.Text
              extendClasses={fontBase ? `fs-${fontBase}` : 'a-buttonCustom_text'}
            >
              {children}
            </Typography.Text>
          )
        }
        {icon && icon.align === 'right' && <span className="a-buttonCustom_icon-right"><Icon iconName={icon.name} size={icon.size} /></span>}
      </>
    )}
  </button>
);

export default ButtonCustom;
